
import { defineComponent } from "vue";
import { loadPaginatedECWalletHistory } from "@/api/onlineshop";

export default defineComponent({
  name: "ecwallethistory",
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.loadPaginatedECWalletHistory();
  },
  methods: {
    async loadPaginatedECWalletHistory() {
      this.loading = true;
      const response = await loadPaginatedECWalletHistory(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
});
